
import IndependentResearcherFeed from "./IndependentResearcherFeed";
import IndependentResearcherRealWorldProblems from "./IndependentResearcherRealWorldProblems";
import { IndependentResearherProfile } from "./IndependentResearherProfile"
const IndependentResearcherHome = () => {
  
  return (
    <div className="container mx-auto md:px-4 mt-6 mb-4">

      <div className="flex relative">
        <div className="hidden md:block w-1/4 px-2">
          <div className="sticky top-[80px] max-h-[calc(100vh-80px)] overflow-y-auto scrollbar-hidden">
            <IndependentResearherProfile />
          </div>
        </div>
        {/* Center Section */}
        <div className="w-full md:w-2/4 md:px-2">
         <div className="sticky top-[80px] max-h-[calc(100vh-80px)] overflow-y-auto scrollbar-hidden">
           <IndependentResearcherFeed/>
          </div>
        </div>
        <div className="hidden md:block w-1/4 px-2">
          <div className="sticky top-[80px]  max-h-[calc(100vh-80px)] overflow-y-auto scrollbar-hidden">
            <IndependentResearcherRealWorldProblems/>
          </div>
        </div>
      </div>
    </div>
  )
}

export default IndependentResearcherHome